/**
 * analytics.ts — Integração Google Analytics 4 (GA4), opcional e inerte por padrão.
 *
 * Só é ativada quando `VITE_GA_ID` está definido no ambiente. Sem o ID, todas as
 * funções viram no-op — nenhum script é carregado e nenhum cookie é criado.
 * Usa Consent Mode v2 com armazenamento negado por padrão (LGPD); chame
 * `grantAnalyticsConsent()` após o aceite do usuário.
 */

export const GA_ID = import.meta.env.VITE_GA_ID as string | undefined;
export const analyticsEnabled = Boolean(GA_ID);

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let initialized = false;

export function initAnalytics(): void {
  if (!analyticsEnabled || initialized || typeof window === "undefined") return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag("js", new Date());
  // Consent Mode v2 — tudo negado por padrão (LGPD).
  window.gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
}

export function trackPageView(path: string): void {
  if (!analyticsEnabled || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function grantAnalyticsConsent(): void {
  if (!analyticsEnabled || typeof window === "undefined" || !window.gtag) return;
  window.gtag("consent", "update", { analytics_storage: "granted" });
}
